import { atomWithStorage } from "jotai/utils";

import type { ShipmentDateRangeValue } from "../constants/shipment-date-filter.ts";
import {
	coerceShipmentDateRange,
	defaultShipmentDateRange,
} from "../constants/shipment-date-filter.ts";

// Validate on read: localStorage can hold a stale or hand-edited value (e.g.
// after the option list changes). Coercing invalid values back to the default
// keeps the dropdown display and the grid filter in agreement instead of
// showing the default while filtering out every shipment.
const validatedStorage = {
	getItem: (
		key: string,
		initialValue: ShipmentDateRangeValue,
	): ShipmentDateRangeValue => {
		const stored = globalThis.localStorage.getItem(key);
		if (stored == null) {
			return initialValue;
		}
		try {
			return coerceShipmentDateRange(JSON.parse(stored));
		} catch {
			return initialValue;
		}
	},
	setItem: (key: string, value: ShipmentDateRangeValue): void => {
		globalThis.localStorage.setItem(key, JSON.stringify(value));
	},
	removeItem: (key: string): void => {
		globalThis.localStorage.removeItem(key);
	},
};

/**
 * Persists the user's selected "Show Shipments From Last" timeframe across
 * sessions so the Shipment Board reopens with their last choice.
 */
export const shipmentDateRangeAtom = atomWithStorage<ShipmentDateRangeValue>(
	"shipment-board-date-range",
	defaultShipmentDateRange,
	validatedStorage,
	// Read (and validate) the persisted value synchronously on init so the
	// dropdown and grid filter agree on first render rather than briefly using
	// the default before hydration.
	{ getOnInit: true },
);
